export const documentUtil = {
  /**
   * 天华云地址前缀
   */
  edocPrefix: 'https://edoc.thape.com.cn:8022/index.html#doc/enterprise/',

  /**
   * 根据ID获取天华云地址
   */
  getEdocPathById: (id: number) => {
    return `${documentUtil.edocPrefix}${id}`;
  },

  /**
   * PPM地址前缀
   */
  ppmPrefix: 'https://plm.thape.com.cn',

  getPpmPath: () => {
    return "https://plm.thape.com.cn/auth/openid_connect"
    // return `${documentUtil.ppmPrefix}`;
  },

  /**
   * 根据ID获取PPM项目地址
   */
  getPpmProjectPath: (id: number) => {
    return `${documentUtil.ppmPrefix}/projects/${id}`;
  },

  /**
   * 根据项目ID获取PPM项目工作包链接
   */
  getPpmProjectWorkPackagesPath: (id: number) => {
    return `${documentUtil.ppmPrefix}/projects/${id}/work_packages`;
  },
  
  /**
   * 根据项目ID和工作包ID获取工作包详情链接
  */
  getPpmProjectWorkPackagePath: (workpackId: string | number, projectId: number) => {
    return `${documentUtil.ppmPrefix}/projects/${projectId}/work_packages/${workpackId}/activity`;
  },
  
  /**
   * 根据项目ID获取项目设置页链接
  */
  getPpmProjectSettingPath: (id: number) => {
    return `${documentUtil.ppmPrefix}/projects/${id}/settings/general/`;
  },

  /**
   * 根据工作包ID获取工作包详情链接
   */
  getPpmWorkPackagePath: (id: number) => {
    return `${documentUtil.ppmPrefix}/work_packages/${id}/activity`;
  },

  /**
   * 传入path获取完整路径
   */
  getFullPath: (path: string) => {
    return `${documentUtil.ppmPrefix}${path.startsWith('/') ? path : '/' + path}`;
  },
};
